<template>
    <div class="topbar">
        <a href="javascript:;" class="koa-icon" @click="toDownload"></a>
        <!-- 语言下拉选择 -->
        <div class="lang-select">
            <div
                class="cur-lang"
                :class="[lang, { show: showLangBtn }]"
                @click="toggleDropdown"
            >
                <div
                    class="dropdown-arrow"
                    :class="{ open: dropDownState }"
                ></div>
            </div>
            <ul class="lang-select-dropdown" :class="{ open: dropDownState }">
                <li class="lang-btn lang-en-btn" @click="changeLang('en')"></li>
                <li class="lang-btn lang-ru-btn" @click="changeLang('ru')"></li>
            </ul>
        </div>
        <div class="btn-audio" :class="[audioState]" @click="playBgm"></div>
        <!-- 即时下载 -->
        <a
            href="javascript:;"
            class="btn-dw"
            :class="[lang]"
            title="即时下载"
            @click="toDownload"
            >{{ $t('base.download_btn') }}</a
        >
        <!-- 活动规则 -->
        <a
            href="javascript:;"
            class="btn-rule"
            :class="[lang]"
            title="活动规则"
            @click.stop="openRule"
            >{{ $t('base.rule_btn') }}</a
        >
    </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import LS from '@/utils/storage.js';
import { LS_PREFIX } from '@/config';

export default {
    name: 'topbar',
    data() {
        return {
            // 语言选择下拉
            dropDownState: false
        };
    },
    computed: {
        lang() {
            return this.$store.state.lang;
        },
        showLangBtn() {
            return this.$store.state.game.view == 'start';
        },
        audioState() {
            return this.$store.state.bgmPlayState ? 'on' : 'off';
        }
    },
    methods: {
        ...mapMutations([
            'SHOW_POPUP',
            'SET_LANG',
            'PLAY_SOUND',
            'STOP_SOUND',
            'SET_STATE'
        ]),
        ...mapActions(['getDownloadScore']),
        toggleDropdown() {
            this.PLAY_SOUND('button');
            console.log('drop');
            this.dropDownState = !this.dropDownState;
        },
        // 显示活动规则
        openRule() {
            this.PLAY_SOUND('button');
            this.SHOW_POPUP('rule');
        },
        changeLang(lang) {
            LS.save(LS_PREFIX + 'lang1', lang);
            this.SET_LANG(lang);
            this.$i18n.locale = lang;
            this.dropDownState = false;
        },
        toDownload() {
            this.PLAY_SOUND('button');
            this.getDownloadScore();
            window.open('https://app.adjust.com/ts8zich_dz016n6');
        },
        playBgm() {
            let _bgmState = this.$store.state.bgmPlayState;
            let _volume = this.$store.state.bgmVolume;
            if (!_bgmState) {
                createjs.Sound.play('bgm', {
                    loop: -1,
                    volume: _volume
                });
            } else {
                createjs.Sound.stop();
            }
            // 更新BGM播放状态
            this.SET_STATE({
                key: 'bgmPlayState',
                val: !_bgmState
            });
        }
    },
    mounted() {}
};
</script>

<style lang="less" scoped>
.topbar {
    display: flex;
    align-items: center;
    .koa-icon {
        width: 104px;
        height: 103px;
        background: url(~@/assets/img/koa_icon.png) center/100% 100% no-repeat;
    }

    .lang-select {
        margin-left: 22px;
        margin-right: 12px;
        position: relative;
        z-index: 999;

        .cur-lang {
            width: 75px;
            height: 84px;
            position: relative;
            z-index: 1000;
            pointer-events: none;
            opacity: 0;
            visibility: hidden;

            &.show {
                pointer-events: auto;
                opacity: 1;
                visibility: visible;
            }

            .dropdown-arrow {
                width: 18px;
                height: 15px;
                background: url(~@/assets/img/dropdown_open.png) center/100%
                    100% no-repeat;
                position: absolute;
                left: 30px;
                bottom: 18px;
                // transition: transform 0.2s ease-in-out;

                &.open {
                    transform: rotate(180deg);
                }
            }
            &.zh {
                background: url(~@/assets/img/en_btn_h.png) center/100% 100%
                    no-repeat;
            }
            &.en {
                background: url(~@/assets/img/en_btn_h.png) center/100% 100%
                    no-repeat;
            }
            &.ru {
                background: url(~@/assets/img/ru_btn_h.png) center/100% 100%
                    no-repeat;
            }
        }

        &-dropdown {
            width: 213px;
            height: 0;
            background: url(~@/assets/img/lang_down.png) center/100% 100%
                no-repeat;
            position: absolute;
            top: 37px;
            left: -72px;
            z-index: 1;
            opacity: 0;
            transition: height 0.1s linear, opacity 0.1s linear;
            will-change: height;
            box-sizing: border-box;
            padding: 45px 73px 0;
            pointer-events: none;

            &.open {
                height: 245px;
                opacity: 1;
                pointer-events: initial;
            }

            .lang-btn {
                width: 73px;
                height: 84px;

                &.lang-en-btn {
                    background: url(~@/assets/img/en_btn.png) center/100% 100%
                        no-repeat;
                    margin-top: 3px;
                }

                &.lang-ru-btn {
                    margin-top: 12px;
                    background: url(~@/assets/img/ru_btn.png) center/100% 100%
                        no-repeat;
                }
            }
        }
    }

    .btn-audio {
        width: 75px;
        height: 84px;
        margin-left: 10px;
        background: url(~@/assets/img/btn_audio_off.png) center/100% 100%
            no-repeat;

        &.on {
            background: url(~@/assets/img/btn_audio_on.png) center/100% 100%
                no-repeat;
        }
    }

    .btn-rule {
        width: 168px;
        height: 84px;
        line-height: 82px;
        box-sizing: border-box;
        text-align: center;
        background: url(~@/assets/img/btn_rule.png) center/100% 100% no-repeat;
        position: relative;
        z-index: 1001;
        color: #ac842d;
        font-size: 20px;
        font-weight: bold;
        font-family: Arial, 'Microsoft YaHei';
    }

    .btn-dw {
        width: 188px;
        height: 84px;
        line-height: 82px;
        // list-style: none;
        // padding-top: 22px;
        padding-right: 30px;
        box-sizing: border-box;
        text-align: center;
        background: url(~@/assets/img/btn_dw.png) center/100% 100% no-repeat;
        margin-left: 14px;
        position: relative;
        z-index: 1001;
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        font-family: Helvetica, Arial, 'Microsoft YaHei';

        &.ru {
            letter-spacing: -1px;
        }
    }

    .lang-btn,
    .btn-rule,
    .btn-dw {
        &:active {
            transform: scale(0.94);
        }
    }
}
</style>
